import React from 'react';

import { Datenschutz, Impressum, Footer, Blog, Whatprotactics, Possibility, Header } from './containers';
import { Brand, Navbar } from './components';

import './App.css';

const App = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <Blog />
    <Possibility />    
    <Whatprotactics />
    <Footer />
    <Impressum />
    <Datenschutz />
  </div>
);

export default App;
